import {
  Box,
  List,
  ListItem,
  ListItemButton,
  SwipeableDrawer,
  Typography,
  styled,
} from "@mui/material";

import { DefaultUrlWeb } from "config/Configuration";
import NumberFormats from "./NumberFormats";
import { useMemo, useState } from "react";
import SearchInput from "./SearchInput";
import { search } from "utils/helpers/search";

export function CoinDrawerList({
  onOpen,
  onClose,
  open,
  onCoinClick,
  coinList,
  isDigital,
}) {
  const [value, setValue] = useState();

  const formattedItems = useMemo(
    () => coinList?.filter((coin) => coin.isDigital === isDigital),
    [coinList, isDigital]
  );

  const handleSearch = (e) => {
    const value = e.target.value;
    setValue(value);
  };

  const searchCoinList = useMemo(() => {
    const valueExists = value;

    if (valueExists) {
      return search({
        list: formattedItems,
        value,
        keys: ["name", "availableBalance"],
      }).sort((a, b) => b?.availableBalance - a?.availableBalance);
    } else {
      const formattedItemsAvailableBalance = formattedItems?.filter((item) => {
        if (item?.availableBalance || item?.availableBalance === 0)
          return item?.availableBalance > 0;
        else return item;
      });

      return formattedItemsAvailableBalance?.sort(
        (a, b) => b?.availableBalance - a?.availableBalance
      );
    }
  }, [formattedItems, value]);

  const handleItemClick = (coin) => {
    onCoinClick(coin);
    onClose();
  };

  return (
    <SwipeableDrawer
      anchor="left"
      open={open}
      onClose={onClose}
      onOpen={onOpen}
    >
      <Box pt={2} px={1}>
        <SearchInput value={value} onChange={handleSearch} />
      </Box>

      <List>
        {searchCoinList?.map((coin, index) => (
          <ListItemStyle key={index}>
            <ListItemButtonStyle onClick={() => handleItemClick(coin)}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
              >
                <img src={DefaultUrlWeb + coin?.imageUrl} alt={coin?.name} />
                {coin.name}
              </Box>

              <Typography>
                <NumberFormats value={coin?.availableBalance} />
              </Typography>
            </ListItemButtonStyle>
          </ListItemStyle>
        ))}
      </List>
    </SwipeableDrawer>
  );
}

const ListItemButtonStyle = styled(ListItemButton)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  paddingTop: theme.spacing(1.25),
  paddingBottom: theme.spacing(1.25),
  fontSize: "16px",
  fontWeight: "400",
  color: theme.palette.text.main,
  paddingLeft: theme.spacing(0.6),
  minWidth: "300px",
  cursor: "pointer",

  img: {
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    objectFit: "contain",
    marginRight: "15px",
    backgroundColor: theme.palette.grey[30],
    padding: theme.spacing(0.6),
  },
}));

const ListItemStyle = styled(ListItem)(({ theme }) => ({
  padding: theme.spacing(0, 2),
  borderBottom: `1px solid ${theme.palette.modules.border}`,
}));

export default CoinDrawerList;
